import { Table } from "@tanstack/react-table";
import FacetedFilters from "@/pages/(app)/returns/list/components/faceted/faceted-filters";
import ClearFilterButton from "@/pages/(app)/returns/list/components/returns-data-table/clear-filter-button";
import ReturnsDataTableFilter from "@/pages/(app)/returns/list/components/returns-data-table/returns-data-table-filter";
import ShopViewSelector from "../shop-views/shop-view-selector";
import SearchInput from "./search-input";
import { DownloadResultsButton } from "./export-return-request-fields/dowload-return-request-fields-button";

interface ReturnsDataTableToolbarProps<TData> {
  table: Table<TData>;
}

export default function ReturnsDataTableToolbar<TData>({
  table,
}: ReturnsDataTableToolbarProps<TData>) {
  return (
    <div>
      <div className="flex items-center justify-between h-8">
        <SearchInput />
        <div className="flex items-center justify-between h-8">
          <div className="flex flex-row items-center gap-1">
            <ReturnsDataTableFilter />
          </div>
          <div className={"flex flex-row gap-1 items-center"}>
            <ClearFilterButton />
            <ShopViewSelector />
            <DownloadResultsButton table={table} />
          </div>
        </div>
      </div>
      <FacetedFilters />
    </div>
  );
}
